import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const dishesService = {
  getAllDishes: () =>
    axiosService.get(urls.dishes.dishesD).then((value) => value.data),
  getAllDishesPaginated: ({ page, word = "", type }) =>
    axiosService
      .get(`${urls.dishes.dishesD}/paginated`, {
        params: {
          page,
          search: word,
          ...(type !== undefined && { type }),
        },
      })
      .then((value) => value.data),
  createDishes: (data) =>
    axiosService.post(urls.dishes.dishesD, data).then((value) => value.data),
  updateDishesById: (id, data) =>
    axiosService
      .patch(`${urls.dishes.dishesD}/update/${id}`, data)
      .then((value) => value.data),
  deleteDishesById: (id) =>
    axiosService.destroy(`${urls.dishes.dishesD}/${id}`),
  duplicateDishesById: (id, multiplier = 1, name) =>
    axiosService
      .post(`${urls.dishes.dishesD}/duplicate`, { id, multiplier, name })
      .then((value) => value.data),
  getDishById: (id) =>
    axiosService
      .get(`${urls.dishes.dishesD}/details/${id}`)
      .then((value) => value.data),
  deleteDishImage: (id) =>
    axiosService
      .destroy(`${urls.dishes.dishesD}/${id}/image`)
      .then((value) => value.data),
  // JSON (not multipart) — one request replaces N calls to createDishes.
  // Matches/updates existing dishes by name.en server-side.
  bulkUpsertDishes: (dishes, skipUnchanged = true) =>
    axiosService
      .post(`${urls.dishes.dishesD}/bulk`, { dishes, skipUnchanged })
      .then((value) => value.data),
  updateBulkDishesPrices: (dishes) =>
    axiosService
      .patch(`${urls.dishes.dishesD}/bulk-update-price`, dishes)
      .then((value) => value.data),
  syncWithProductsAndSemiFinishedProducts: (id) =>
    axiosService
      .patch(
        `${urls.dishes.dishesD}/sync-with-products-and-semi-finished-products/${id}`
      )
      .then((value) => value.data),

  exportAllDishesWithIngredients: () =>
    axiosService
      .get(`${urls.dishes.dishesD}/all-dishes-with-ingredients`)
      .then((value) => value.data),
};

export { dishesService };
